import React, { useRef } from 'react';

function toDigitArray(value, length) {
  const digits = String(value).replace(/\D/g, '').slice(0, length).split('');
  while (digits.length < length) {
    digits.push('');
  }
  return digits;
}

export function DigitBoxInput({
  length = 6,
  value = '',
  onChange,
  label,
  id,
}) {
  const inputsRef = useRef([]);
  const digits = toDigitArray(value, length);

  const emitValue = (nextDigits) => {
    onChange(nextDigits.join('').replace(/\D/g, '').slice(0, length));
  };

  const focusInput = (index) => {
    const input = inputsRef.current[index];
    if (input) {
      input.focus();
      input.select();
    }
  };

  const handleChange = (index, event) => {
    const raw = event.target.value.replace(/\D/g, '');

    if (!raw) {
      const next = [...digits];
      next[index] = '';
      emitValue(next);
      return;
    }

    const next = [...digits];
    let cursor = index;

    for (const char of raw) {
      if (cursor >= length) break;
      next[cursor] = char;
      cursor += 1;
    }

    emitValue(next);

    if (cursor < length) {
      focusInput(cursor);
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === 'Backspace' && !digits[index] && index > 0) {
      event.preventDefault();
      const next = [...digits];
      next[index - 1] = '';
      emitValue(next);
      focusInput(index - 1);
      return;
    }

    if (event.key === 'ArrowLeft' && index > 0) {
      event.preventDefault();
      focusInput(index - 1);
      return;
    }

    if (event.key === 'ArrowRight' && index < length - 1) {
      event.preventDefault();
      focusInput(index + 1);
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pasted = event.clipboardData
      .getData('text')
      .replace(/\D/g, '')
      .slice(0, length);
    onChange(pasted);
    focusInput(Math.min(pasted.length, length - 1));
  };

  return (
    <div>
      {label && (
        <label
          htmlFor={id ? `${id}-0` : undefined}
          className="mb-2 block text-sm font-medium text-gray-700"
        >
          {label}
        </label>
      )}
      <div
        className="flex justify-center gap-2 sm:gap-3"
        onPaste={handlePaste}
      >
        {digits.map((digit, index) => (
          <input
            key={index}
            ref={(el) => {
              inputsRef.current[index] = el;
            }}
            id={id && index === 0 ? `${id}-0` : undefined}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            value={digit}
            onChange={(event) => handleChange(index, event)}
            onKeyDown={(event) => handleKeyDown(index, event)}
            onFocus={(event) => event.target.select()}
            aria-label={`หลักที่ ${index + 1}`}
            className="flex h-14 w-11 items-center justify-center rounded-lg border-2 border-gray-200 bg-white text-center text-2xl font-bold text-brand-red shadow-sm transition-colors focus:border-brand-red focus:outline-none sm:h-16 sm:w-14 sm:text-3xl"
          />
        ))}
      </div>
    </div>
  );
}
